(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-black-friday"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bind(scope){scope.querySelectorAll('[data-mova-bf]').forEach(function(bar){if(bar.dataset.bound)return;bar.dataset.bound='true';const end=Date.parse(bar.dataset.end),clock=bar.querySelector('[role="timer"]');let timer;
    function tick(){const remaining=Math.max(0,Math.floor((end-Date.now())/1000));if(!remaining){bar.hidden=true;if(timer)clearInterval(timer);return;}const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};Object.keys(values).forEach(function(key){bar.querySelector('[data-bf-'+key+']').textContent=String(values[key]).padStart(2,'0');});clock.hidden=false;}
    tick();if(!bar.hidden)timer=setInterval(tick,1000);
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bind(document);},{once:true});else bind(document);document.addEventListener('shopify:section:load',function(event){bind(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-mystery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('[data-colour-gallery]').forEach(function(gallery){if(gallery.dataset.bound)return;gallery.dataset.bound='1';gallery.querySelectorAll('[data-gallery-image]').forEach(function(btn){btn.addEventListener('click',function(){const img=gallery.querySelector('.mystery-gallery__photo img');img.srcset='';img.src=btn.dataset.galleryImage;img.alt=btn.dataset.galleryLabel;gallery.querySelector('[data-colour-current]').textContent=btn.dataset.galleryLabel;gallery.querySelectorAll('[aria-pressed]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));});});});
    root.querySelectorAll('.mystery').forEach(function(section){
      if(section.dataset.bound)return;section.dataset.bound='1';const country=section.querySelector('[data-mystery-country]');if(country)country.addEventListener('change',function(){const marketForm=country.closest('form'),returnTo=marketForm.querySelector('[name=return_to]');if(returnTo)returnTo.value=location.pathname+location.search;marketForm.submit();});
      const data=JSON.parse(section.querySelector('[data-mystery-data]').textContent),form=section.querySelector('form.mystery__form'),button=section.querySelector('[data-mystery-add]'),status=section.querySelector('[data-mystery-status]'),summary=section.querySelector('[data-mystery-selection]'),input=section.querySelector('[data-mystery-variant]');let busy=false,uncertain=false;
      function box(){return form.querySelector('[name="mystery_box"]:checked')?.value;} function eligible(size){return data.variants.filter(function(v){return v.option1===size&&v.option3===box()&&v.available;});}
      const ended=()=>Date.now()>=Date.parse(section.dataset.offerEnd);const money=new Intl.NumberFormat(data.locale,{style:'currency',currency:data.currency});
      section.querySelectorAll('[name="mystery_size"]').forEach(function(radio){radio.disabled=!eligible(radio.value).length;});
      function update(){if(ended()){button.disabled=true;button.textContent=data.strings.ended;status.textContent=data.strings.ended;return;}if(busy||uncertain)return;const size=form.querySelector('[name="mystery_size"]:checked')?.value,n=parseInt(box()),variant=data.variants.find(v=>v.option3===box()),total=n*data.singlePrice+(n>3?data.jacketPrice:0);section.querySelectorAll('[name="mystery_size"]').forEach(r=>{r.disabled=!eligible(r.value).length;if(r.disabled)r.checked=false;});const selected=form.querySelector('[name="mystery_size"]:checked')?.value;button.disabled=!selected||!eligible(selected).length;button.textContent=!selected?data.strings.choose:button.disabled?data.strings.unavailable:data.strings.add;summary.textContent=selected?data.strings.selection.replace('[size]',selected).replace('[count]',n).replace('[gift]',n>3?data.strings.giftBadge:''):data.strings.choose;section.querySelector('[data-mystery-price]').textContent=money.format(variant.price/100);section.querySelector('[data-mystery-badge]').textContent=n===3?data.strings.threeBadge:data.strings.giftBadge;section.querySelector('[data-mystery-comparison]').textContent=data.strings.comparison.replace('[total]',money.format(total/100)).replace('[saving]',money.format((total-variant.price)/100));const currentTopPack=n===3?Math.round(data.singlePrice*n*.8):null;section.querySelector('[data-mystery-advantage]').textContent=n===3?data.strings.advantage.replace('[amount]',money.format((currentTopPack-variant.price)/100)):'';input.value='';status.textContent='';}
      form.addEventListener('change',update);update();setInterval(function(){if(ended())update();},30000);
      form.addEventListener('submit',async function(event){event.preventDefault();if(ended()){update();return;}if(busy||uncertain)return;const size=form.querySelector('[name="mystery_size"]:checked')?.value,candidates=eligible(size);if(!candidates.length){update();return;}const variant=candidates[Math.floor(Math.random()*candidates.length)];input.value=variant.id;if(data.preview){status.textContent=data.strings.preview;return;}busy=true;button.disabled=true;button.textContent=data.strings.adding;status.textContent='';const root=window.Shopify?.routes?.root||'/';
        try{const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});const result=await response.json();if(!response.ok){busy=false;button.textContent=data.strings.add;button.disabled=false;status.textContent=result.description||data.strings.error;return;}window.location.assign(root+'cart');}
        catch(error){uncertain=true;status.textContent=data.strings.error+' ';const link=document.createElement('a');link.href=root+'cart';link.textContent=data.strings.viewCart;status.append(link);button.textContent=data.strings.viewCart;button.disabled=true;}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
